import React, {useState, useEffect, useRef, useLayoutEffect} from 'react';
import "../../css/home.scss";
import { useHistory } from 'react-router-dom';
import Cookies from 'js-cookie';
import Mappings from '../actions/mappings';
import { CloudSearchAPICall } from '../actions/searchcall';
import PropertyDropDown from './reusable/PropertyDropDown';
import betaRS11Logo from '../../images/betaRS11Logo.png';
import LoginBottomSheet from './Mobile/LoginBottomSheet';
import mobileBgImage from '../../images/mobileBgImage.webp';
import webBgImage from '../../images/webBgImage.webp';
import { PropertySuggester } from '../actions/search_utils';
import MessagePopup from './reusable/MessagePopup';

function Home() {
    const history = useHistory();
    const ImageElement = useRef();
    const dropDownElement = useRef();
    const cloudSearchAPICall = useRef(new CloudSearchAPICall());
    const propertySuggester = useRef(new PropertySuggester());

    const footerOptions = ['aboutUs', 'help', 'contactUs', 'rs11Foundation', 'press', 'career', 'privacy', 'terms'];

    const homeContentElement = useRef(null);
    const businessNameElement = useRef(null);

    const dropdownList = [
        'Restaurants & Food',
        'Manufacturing',
        // 'Automotive & Boat',
        // 'Agriculture',
        'Service Businesses',
        'Retail',
        'Entertainment & Recreation',
        'Building & Construction',
        'Transportation & Storage',
        // 'Wholesale & Distributors',
        // 'Airbnb', Removed
        'Accommodation and Food Services',
        'Construction',
        'Wholesale Trade',
        'Retail Trade',
        'Transportation and Warehousing',
        'Professional, Scientific, and Technical Services',
        'Arts, Entertainment, and Recreation',
        'Accommodation and Food Services'
    ];

    const industryType = Cookies.get('industry') || dropdownList;
    
    const [searchValue, onSearch] = useState('');
    const [properties, setProperties] = useState([]);
    const [dropdown, showDropdown] = useState(true);
    const [suggester, setSuggester] = useState('');
    const [checkToken, setcheckToken] = useState(true);
    const [businessName, setBusinessName] = useState('');
    const [isAccountBottomSheetOpen, setIsAccountBottomSheetOpen] = useState(false);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [showError, setShowError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [searchText, setSearchText] = useState('Search');
    const [showLoginContent, setShowLoginContent] = useState(true);
    const [showLocationError, setShowLocationError] = useState(false);

    let accessToken = Cookies.get('access_token') ?? null;
    let userId = Cookies.get('rs11_user_id') ?? 0;
    
    if (checkToken) {
        setcheckToken(false);
        if (accessToken) {
            const token_expires_in = Cookies.get('token_expires_in');
            var time = new Date();
            const current_time = time.toISOString();
            if (current_time > token_expires_in) {
                Cookies.remove('access_token');
                Cookies.remove('token_expires_in');
                Cookies.remove('username');
            }
        }
    }

    useLayoutEffect(() => {
        const handleResize = () => setScreenWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
    
        return () => {
          window.removeEventListener('resize', handleResize);
        };
      }, []);

    useEffect(() => {
        // Add event listener to document
        document.addEventListener('click', handleClickOutside, true);
        document.title = 'RS11 | Home';

        // Clean up event listener on unmount
        return () => {
          document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);

    const handleClickOutside = (event) => {
        if (homeContentElement.current && !homeContentElement.current.contains(event.target)) {
            showDropdown(false);
        }
    };

    const fetchLocationData = async () => {
        try {
            const response = await fetch('https://ipapi.co/json/');
            const data = await response.json();
            window.localStorage.setItem('userLatlong', JSON.stringify([ data.longitude,data.latitude ]));
        } catch (error) {
            console.log('Error fetching location data:', error);
            window.localStorage.setItem('userLatlong', null);
        }
    };

    useEffect (() => {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    window.localStorage.setItem('userLatlong', JSON.stringify([ longitude,latitude ]));
                },
                (error) => {
                    console.log("Error getting location:", error.message);
                    fetchLocationData();
                    // setShowLocationError(true);
                }
            );

        } else {
            console.log("Geolocation is not available");
            fetchLocationData();
            setShowLocationError(true);
        }
    }, []);

    const handleSignIn = () => {
        setShowLoginContent(true);
        window.dataLayer.push({'event': 'home_sign_in'})
        setIsAccountBottomSheetOpen(true);
    }

    const handleCreateAccount = () => {
        setShowLoginContent(false);
        window.dataLayer.push({'event': 'home_create_account'})
        setIsAccountBottomSheetOpen(true);
    }

    const handleCategoryAPICall = () => {
        cloudSearchAPICall.current.getSearchCategory(searchValue, suggester, industryType, (res) => {
            if (res['hits']) {
                const business = res['hits']['hit'][0];
                let storeSuggester = suggester;
                if (res['hits']['hit'].length == 0) { storeSuggester = '' }

                window.localStorage.setItem('suggester', storeSuggester);
                window.localStorage.setItem('searchValue', searchValue);
                window.localStorage.setItem('selectedBusiness', JSON.stringify(business));
                window.localStorage.setItem('nameSuggester', null);
                window.localStorage.setItem('businessName', null);

                history.push({
                    pathname: '/map',
                    state: { businessData: null}
                });

                setSearchText('Search'); 
            }
            else {
                setErrorMessage('Something went wrong.');
                setShowError(true);
                setSearchText('Search');
                return
            }
        });
    }

    useEffect(() => {
        window.handleConsoleCommand = handleConsoleCommand;
    
        return () => {
          delete window.handleConsoleCommand;
        };
    }, []);

    const handleConsoleCommand = (getMap, businessName, businessAddress, searchValue, suggester) => {
        if (getMap === 'getMap') {
            cloudSearchAPICall.current.getBusinessName(businessName, businessAddress, searchValue, suggester, industryType, (res) => {
                const business = res['hits']['hit'][0];
                if (business != undefined) {
                    window.localStorage.setItem('selectedBusiness', JSON.stringify(business));
                    window.localStorage.setItem('nameSuggester', 'name');
                    window.localStorage.setItem('suggester', suggester);
                    window.localStorage.setItem('searchValue', searchValue);

                    history.push({
                        pathname: '/map',
                        state: { businessData: business }
                    });
                }
            });
        }
    }

    const handleNext = () => {
        window.dataLayer.push({
            'event': 'search', 
            'searchCity': suggester == 'city' ? searchValue : '',
            'searchZipcode': suggester == 'zipcode' ? searchValue : '',
            'searchBusiness': businessName
        });
        setSearchText('Searching...');
        if (searchValue.trim().length == 0) {
            setErrorMessage('Please enter a City, Town or ZIP Code.');
            setShowError(true);
            setSearchText('Search');
            return
        }
        handleCategoryAPICall();
    }
    

    const handleChange = (e) => {
        (showError) && setShowError(false);
        const searchBusiness = e.target.value;
        (businessName != '') && setBusinessName('');
        (dropDownElement.current) && (dropDownElement.current.style.pointerEvents = 'none');
        onSearch(searchBusiness);
        showDropdown(true);
        if (searchBusiness == '') {
            showDropdown(false);
            return;
        }
        propertySuggester.current.getSuggestionsWithCallback(searchBusiness, (res, suggester) => {
            if (!res || !suggester) return;
            setProperties(res['suggest']['suggestions']);
            setSuggester(suggester);
        });

    };

    const onSelectProperty = (e, property) => {
        showDropdown(false);
        (dropDownElement.current) && (dropDownElement.current.style.pointerEvents = '');
        onSearch(property['suggestion']);
        Cookies.set("searchBusiness", property['suggestion']);
        (businessNameElement.current) && (businessNameElement.current.focus());
    };

    const handleAccountBottomSheetOpen = () => {
        setIsAccountBottomSheetOpen(true)
    }

    const handleAccountBottomSheetClose = (boolean) => {
        setIsAccountBottomSheetOpen(false)
    }

    const handleFooterPages = (i) => {
        if(i == 0) {
            history.push('/about-us')
        };
        if(i == 1){
            history.push('/help')
        };
        if(i == 3){
            history.push('/rs11-foundation')
        };
        if(i == 4){
            history.push('/press')
        };
        if(i == 5){
            history.push('/careers')
        };
        if(i == 6){
            history.push('/privacy-policy')
        };
        if(i == 7){
            history.push('/terms')
        };
    }

    return (
        <div className='mobile-home-page'>
            {
                (isAccountBottomSheetOpen) && 
                    <LoginBottomSheet 
                        isBottomSheetOpen={isAccountBottomSheetOpen}
                        onBottomSheetOpen={handleAccountBottomSheetOpen}
                        onBottomSheetClose={handleAccountBottomSheetClose}
                        showLoginContent={showLoginContent}
                    />
            }
            <div id="mobile-homepage" className="backgroundimage" ref={ImageElement} style={{'backgroundImage': `url(${screenWidth < 1200 ? mobileBgImage : webBgImage})`}}>    
                <div className='home-page-content'>
                    {/* `home_rs11_logo` class name is using in GA events. */}
                    <img className='home_rs11_logo' src={betaRS11Logo} alt='RS11-logo' width='100px' height='78px' />
                        <div className='content-container' id='search-container' ref={homeContentElement}>
                            <p className='find-text'>Discover AI Powered Business Valuations</p>
                            <p className='find-info'>RS11 is in the process of estimating the value of ALL Small, Medium-sized Businesses (SMBs) in the US, which is not easy.</p>
                            <p className='find-info'><span>NOTE:  </span>Beta Version.  SMB valuations may initially be inaccurate and/or exclude real estate values.  Newly valued SMBs are being added all the time, while some valued SMBs may now be out of business.</p>
                            <div className='property-name'>
                                <input
                                    type="text"
                                    id="cityorcode"
                                    className="search-input"
                                    autoComplete={"off"}
                                    placeholder="Enter City, Town or ZIP Code of Business"
                                    value={searchValue}
                                    onChange={(e) => handleChange(e)}
                                />
                                {
                                        (showError) && (
                                        <p className='error-text'>{errorMessage}</p>)
                                    }
                                {
                                    dropdown && (
                                        <div className={"properties-container-mobile"}>
                                            <ul>
                                                <PropertyDropDown properties={properties} onSelectProperty={onSelectProperty} />
                                            </ul>
                                        </div>
                                    )
                                }
                            </div>
                            <div className='home-search'>
                                <button className={`submit ${(searchText != 'Search') && 'disable-click'}`} onClick={handleNext}>
                                    {searchText}
                                </button>
                            </div>
                            {
                                ((Cookies.get('access_token') ?? null) == null) && (
                                <div className='user-account-actions'>
                                    <div>
                                        <span className='member-text'>Already member? </span>
                                        <span className='login-text' onClick={() => handleSignIn()}>Sign In</span>
                                    </div>
                                    <div>
                                        <span className='member-text'>New to RS11? </span>
                                        <span className='login-text' onClick={() => handleCreateAccount()}>Create Account</span>
                                    </div>
                                </div>
                                )
                            }

                        </div>
                </div>
            </div> 
            <div className='footer-container' id='home-footer-container'>
                <div className='navigate-pages'>
                {
                    footerOptions.map((item, i) => {
                        return(
                            (item == 'contactUs') ? (
                                <a className='footer-text' href = "mailto:support@rs11.com?subject=RS11 Valuation">
                                    Contact Us
                                </a>) : (
                                <p className='footer-text' key={i} onClick={() => handleFooterPages(i)}>
                                    {Mappings[item]}
                                </p>)
                        );
                    })
                }
                </div>
            </div>
            {
                (showLocationError) && (
                <MessagePopup setShowLocationError={setShowLocationError} />)
            }
        </div>
    )
}

export default Home;


